import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=47e1fee4&"
import script from "./Expense.vue?vue&type=script&lang=ts&"
export * from "./Expense.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports